// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	},
    label: {
      search: {
         seeAllProducts: '← See all products',
      }
    }
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};

  // Bind Event for input search Mobile
  var bindEventsMobile = InstantSearchMobile.prototype.bindEvents;
  InstantSearchMobile.prototype.bindEvents = function() {
    bindEventsMobile.call(this);

    var self = this;
    var searchButtonMobile = '.site-nav--mobile .search-button, .js-search-destop';
    var searchInputMobile = '.search-input-group input[type="search"], .wg-search-form .search-input';
    var searchCloseButtonMobile = '.drawer__close > button, .drawer_back a';
    jQ(searchButtonMobile).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputMobile).focus();
      self.openSuggestionMobile();
      jQ(searchCloseButtonMobile).trigger('click');

    });
  }
  
  // Bind Event for input search style 3
  var bindEvents = InstantSearchStyle3.prototype.bindEvents;
  InstantSearchStyle3.prototype.bindEvents = function() {
    bindEvents.call(this);

    var self = this;
    var searchButtonDesktop = '.site-header__links .search-button';
    var searchInputDesktop = '#SearchContainer #search-input';
    var searchCloseButtonDesktop = '.drawer__close > button';
    jQ(searchButtonDesktop).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputDesktop).focus();
      self.openSuggestionStyle3();
      jQ(searchCloseButtonDesktop).trigger('click');

    });
  }

  // Fix search for the Flow theme
  jQ('.site-header__links .search-button').on('click', function() {
    setTimeout(function() {
      boostPFS.initSearchBox();
      if(Utils.isCollectionPage()) jQ('.search-input-group > .boost-pfs-search-box').val('');
    }, 500);
  });


  InstantSearchResult.prototype._setSuggestionPosition = function() {
    var _this = this;
    var searchInputRect = this.$searchInputElement[0].getBoundingClientRect();
    var topPosition = Utils.InstantSearch.isFullWidthMobile() ? searchInputRect.bottom : searchInputRect.bottom + 12;
    var suggestionDirection = _this._getSuggestionDirection();
    var maxWidth = _this._maxWidth();
    // Change top and lef when the scroll
    window.addEventListener('scroll', () => {
      if (!Utils.isMobile()) {
        var searchInputRectScroll = _this.$searchInputElement[0].getBoundingClientRect();
        topPosition = Utils.InstantSearch.isFullWidthMobile() ? searchInputRectScroll.bottom : searchInputRectScroll.bottom + 12;
        if (suggestionDirection == 'left') {
          _this.$wrapper.css({
            top: topPosition + 'px',
            left: searchInputRectScroll.left + 'px'
          })
        } else {
          _this.$wrapper.css({
            top: topPosition + 'px',
            right: (window.innerWidth - searchInputRectScroll.right) + 'px'
          })
        }
      }
    });
  
    var topPx = '';
    var leftPx = '';
    var rightPx = '';
  
    if (suggestionDirection == 'left') {
      topPx = topPosition + 'px';
      leftPx = searchInputRect.left + 'px';
      var offsetRight = jQ(window).width() - searchInputRect.left;
      //var widthWrapper = jQ('#' + this.$wrapper[0].id).width();
      var widthWrapper = maxWidth;
  
      if (offsetRight < maxWidth) {
        widthWrapper = jQ('#' + this.$wrapper[0].id).width();
      }
  
      if (Utils.isMobile()) {
        this.$wrapper.css({
          top: topPx,
          right: '10px',
          left: '10px',
        })
      } else {
        this.$wrapper.css({
          top: topPx,
          left: leftPx
        })
      }
  
      var setSuggetionPosition = () => {
        if (offsetRight < widthWrapper) {
          this.$instantSearchResult.css({
            top: '0px',
            left: '-' + (widthWrapper - offsetRight + 20) + 'px'
          });
        } else {
          this.$instantSearchResult.css({
            top: '0px',
            left: '0px'
          })
        }
      };
      var setSuggetionPopoverPosition = () => {
        this.$popoverElement.css({
          top: '-20px',
          left: '20px'
        })
      };
    } else {
      topPx = topPosition + 'px';
      rightPx = (window.innerWidth - searchInputRect.right) + 'px';
  
      if (Utils.isMobile()) {
        this.$wrapper.css({
          top: topPx,
          right: '10px',
          left: '10px',
        })
      } else {
        this.$wrapper.css({
          top: topPx,
          right: rightPx
        })
      }
  
      var setSuggetionPosition = () => {
        this.$instantSearchResult.css({
          top: '0px',
          right: '0px'
        })
      };
      var setSuggetionPopoverPosition = () => {
        this.$popoverElement.css({
          top: '-20px',
          right: '20px'
        })
      };
    }
  
    return {
      setSuggetionPosition: setSuggetionPosition,
      setSuggetionPopoverPosition: setSuggetionPopoverPosition
    }
  }
  
  InstantSearchResult.prototype._maxHeight = function() {
    var maxHeight = '';
    var maxHeightSetting = Settings.getSettingValue('search.suggestionMaxHeight');
    var suggestionStyle = Settings.getSettingValue('search.suggestionStyle');
    var suggestionProductItemType = Settings.getSettingValue('search.suggestionStyle2ProductItemType')
    var searchInputRect = this.$searchInputElement[0].getBoundingClientRect();
    var topPosition = Utils.InstantSearch.isFullWidthMobile() ? searchInputRect.bottom : searchInputRect.bottom + 12;
    if (maxHeightSetting == '') {
      if (suggestionStyle == 'style2' && suggestionProductItemType == 'list') {
        maxHeight = 564; // Default of the Design for Style 2 column - list
      } else {
        maxHeight = 640;
      }
    } else {
      maxHeight = maxHeightSetting;
    }
  
    if ((maxHeight + topPosition) > (window.innerHeight - 30)) {
      maxHeight = window.innerHeight - topPosition - 30;
    }
    return maxHeight;
  }
  
  InstantSearchResult.prototype._maxWidth = function() {
    var maxWidth = '';
    var maxWidthSetting = Settings.getSettingValue('search.suggestionMaxWidth');
    var suggestionStyle = Settings.getSettingValue('search.suggestionStyle');
    var suggestionStyle2ProductItemType = Settings.getSettingValue('search.suggestionStyle2ProductItemType')
    var suggestionStyle2ProductPerRow = Settings.getSettingValue('search.suggestionStyle2ProductPerRow')
    if (maxWidthSetting == '') {
      if (suggestionStyle == 'style2' && suggestionStyle2ProductItemType == 'grid') {
        maxWidth = 850; // Default of the Design for Style 2 column - list
      } else if (suggestionStyle == 'style2' && suggestionStyle2ProductItemType == 'list' && suggestionStyle2ProductPerRow == '2') {
        maxWidth = 800;
      } else if (suggestionStyle == 'style2' && suggestionStyle2ProductItemType == 'list' && suggestionStyle2ProductPerRow == '1') {
        maxWidth = 526;
      } else {
        maxWidth = '';
      }
    } else {
      maxWidth = maxWidthSetting;
    }
  
    return maxWidth;
  }

  InstantSearchResultItemProduct.prototype.compileTemplate = function() {
    if (this.isShow) {
			var searchTerm = Utils.stripHtml(Globals.currentTerm);
			// Product image
			var imageHTML = '';
			if (Settings.getSettingValue('search.showSuggestionProductImage') && this.imageUrl.length) {
				imageHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.IMAGE);
				imageHTML = imageHTML.replace(/{{imageUrl}}/g, this.imageUrl);
			}
			// Product title
			var productTitle = this.customizeProductTitle();
			productTitle = this._highlightSuggestionResult(productTitle, searchTerm);
			// SKU
			var skuHTML = '';
			if (Settings.getSettingValue('search.showSuggestionProductSku') && this.sku.length) {
				skuHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.SKU);
				skuHTML = skuHTML.replace(/{{sku}}/g, this.sku);
			}
			// Vendor
			var vendorHTML = '';
			if (Settings.getSettingValue('search.showSuggestionProductVendor') && this.vendor.length) {
				vendorHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.VENDOR);
				vendorHTML = vendorHTML.replace(/{{vendor}}/g, this.vendor);
			}
			// Price
           console.log(this.data.price_min)
            var priceHTML = ''
            if(this.data.price_min < this.data.price_max){
              priceHTML  = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE);
              priceHTML = priceHTML.replace(/{{regularPrice}}/g, 'החל מ ' +  Utils.formatMoney(this.data.price_min));
            }else {
              priceHTML = this.compileSuggestionProductPrice();
            }
	
			// Open the result item in new tab when selected
			var newTabAttr = Settings.getSettingValue('search.openProductNewTab') ? 'target="_blank"' : '';

			return this.getTemplate()
				.replace(/{{id}}/g, this.id)
				.replace(/{{escapedBlockType}}/g, Utils.stripHtml(this.parent.type))
				.replace(/{{url}}/g, this.url)
				.replace(/{{newTabAttribute}}/g, newTabAttr)
				.replace(/{{itemProductImage}}/g, imageHTML)
				.replace(/{{title}}/g, productTitle)
				.replace(/{{escapedTitle}}/g, Utils.stripHtml(productTitle))
				.replace(/{{itemProductSku}}/g, skuHTML)
				.replace(/{{itemProductVendor}}/g, vendorHTML)
				.replace(/{{itemProductPrice}}/, priceHTML)
				.replace(/{{class.searchSuggestion}}/g, Class.searchSuggestion)
				.replace(/{{class.searchSuggestionItem}}/g, Class.searchSuggestionItem)
				.replace(/{{class.searchUiAutocompleteItem}}/g, Class.searchUiAutocompleteItem);
		} else {
			return '';
		}
  }
})();